import PageLayout from "../components/site/PageLayout";
import { Reveal } from "../components/site/Reveal";
import { SectionHeading } from "../components/site/SectionHeading";
import { ImgSlot } from "../components/site/ImgSlot";
import { useContent } from "../lib/content";
import { Check } from "lucide-react";

const About = () => {
  const { content } = useContent();
  return (
    <PageLayout title="About">
      <section className="relative pt-16 pb-10 overflow-hidden">
        <div className="ambient" aria-hidden />
        <div className="ambient-grid" aria-hidden />
        <div className="container-tt grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <SectionHeading eyebrow="About" title="A student-led answer to a real problem." description={content.mission.body} />
          </div>
          <div className="lg:col-span-5"><ImgSlot label="Team photo" ratio="4/3" /></div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-tt">
          <SectionHeading eyebrow="Values" title="What guides us." />
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {content.mission.values.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.05}>
                <div className="card-surface card-lift p-8 h-full">
                  <span className="tie-top" aria-hidden />
                  <div className="font-display text-2xl mt-4 text-stone">{v.title}</div>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Dragon Kim Foundation */}
      <section className="py-20 border-y border-border/60 bg-gradient-to-b from-white to-accent/30">
        <div className="container-tt grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="eyebrow"><span className="tie" aria-hidden />Our launch sponsor</div>
            <h2 className="font-display text-3xl md:text-4xl mt-4 leading-tight text-stone">{content.dragonKim.title}</h2>
            <div className="mt-8"><ImgSlot src={content.dragonKim.image} label="Dragon Challenge photo" ratio="4/3" className="shadow-card" /></div>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg text-stone/85 leading-relaxed">{content.dragonKim.body}</p>
            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {content.dragonKim.highlights.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full btn-sky-fill text-white shadow-sky"><Check size={12} /></span>
                  <span className="text-stone">{h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-tt">
          <SectionHeading eyebrow="Founders" title="Three high-schoolers from Orange County." />
          <div className="mt-12 grid md:grid-cols-3 gap-6" data-testid="founders">
            {content.founders.map((f, i) => (
              <Reveal key={f.name} delay={i * 0.05}>
                <div className="card-surface card-lift p-8 h-full">
                  <ImgSlot src={f.image} label="Portrait" ratio="1/1" className="mb-6" />
                  <div className="font-display text-2xl text-stone">{f.name}, {f.age}</div>
                  <div className="text-skyDark text-sm font-medium mt-1">{f.role}</div>
                  <div className="text-muted-foreground text-sm mt-2">{f.school}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default About;
